import React from 'react';
import {Button} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import HeaderSearchCard from '../../../CommonComponents/HeaderSearchCard';
import './style.css';
import useLocalization from '../../../../Localization';

const EventTemplateSchedulerPreviewComponent = (props) => {
  const {ApplicationString} = useLocalization();
  const {eventId} = useParams();
  const navigate = useNavigate();
  const {emailTemplateBody, loading, error} = props;

  const handleBackToScheduler = () => {
    navigate(`/admin/eventEmailTemplatesScheduler/${eventId}`);
  };

  return (
    <div className='main-container'>
      <HeaderSearchCard
        resource='events_email_scheduler'
        dataTestId='EventTemplateSchedulerPreview-button-backToScheduler'
        showAddButton={false}
        showFilter={false}
        extra={
          <>
            <Button
              onClick={handleBackToScheduler}
              id='EventTemplateSchedulerPreview-button-backToScheduler'>
              {
                ApplicationString[
                  'adminActionsDropdownComponent.eventEmailScheduler.backToScheduler'
                ]
              }
            </Button>
          </>
        }
      />
      <div className='listing-container'>
        {error && <div className='event-template-preview-empty'>{error}</div>}
        {!loading && !error && emailTemplateBody?.preview != null && (
          <div
            className='event-template-preview-body'
            dangerouslySetInnerHTML={{__html: emailTemplateBody?.preview}}
          />
        )}
        {!loading && !error && emailTemplateBody?.preview == null && (
          <div className='event-template-preview-empty'>
            {
              ApplicationString[
                'adminActionsDropdownComponent.eventEmailScheduler.noTemplateData'
              ]
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default EventTemplateSchedulerPreviewComponent;
